import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Video, VideoDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getVideo(id: string): Observable<Video> {
        return this.httpClient.get<VideoDto>(`library/videos/${id}`).pipe(mapDto((data) => new Video(data)));
    }
}
